module.exports = __webpack_public_path__ + "static/media/34_B.ca8f682e.png";